import Pagination from '../../components/layout/Pagination'
import Photo from '../../components/Photo'
import topImage from '../../assets/photo/pmd/T5I0020.jpg'
import firstPhoto from '../../assets/photo/pmd/T5I1257.jpg'
import secondPhoto from '../../assets/photo/pmd/T5I9984.jpg'
import thirdPhoto from '../../assets/photo/pmd/T5I0020.jpg'
import fourthPhoto from '../../assets/photo/pmd/T5I3041-2.jpg'
import fifthPhoto from '../../assets/photo/pmd/T5I2665.jpg'

function Pmd() {
    return (
        <>
            <div className="contents-wrapper">
                <h2>#PMD</h2>
                <div className="top-image-container">
                    <img src={topImage} alt="top" />
                </div>
                <div className='photo-wrapper'>
                    <div className='col left-col'>
                        <Photo src={firstPhoto} />
                        <Photo src={thirdPhoto} />
                        <Photo src={fifthPhoto} />
                    </div>
                    <div className='col right-col'>
                        <Photo src={secondPhoto} />
                        <Photo src={fourthPhoto} />
                    </div>
                </div>
            </div>
            <Pagination nextLink='/photo/dishup' />
        </>
    )
}

export default Pmd